// src/crm/tasks/taskUtils.ts
import type { Task, Deal, DealStage } from '../../lib/types'

/** Stages considérés comme "actifs" (deal en cours, pas encore clôturé) */
const ACTIVE_STAGES: DealStage[] = [
  'prospecte',
  'contacte',
  'en_discussion',
  'accepte',
  'brief_envoye',
  'contenu_recu',
  'publie',
]

/**
 * Retourne les tâches non terminées dont la date d'échéance est strictement
 * antérieure à today (format ISO-8601 'YYYY-MM-DD').
 */
export function filterOverdueTasks(tasks: Task[], today: string): Task[] {
  return tasks.filter(
    (t) => t.status !== 'done' && t.dueDate !== null && t.dueDate < today,
  )
}

/**
 * Retourne les deals actifs dont la date d'échéance est strictement
 * antérieure à today.
 */
export function filterBlockedDeals(deals: Deal[], today: string): Deal[] {
  return deals.filter(
    (d) =>
      d.dueDate !== null &&
      d.dueDate < today &&
      ACTIVE_STAGES.includes(d.stage),
  )
}

/**
 * Trie les tâches par due_date ASC, les null en dernier.
 * Retourne un nouveau tableau (pas de mutation).
 */
export function sortTasksByDueDate(tasks: Task[]): Task[] {
  return [...tasks].sort((a, b) => {
    if (a.dueDate === null && b.dueDate === null) return 0
    if (a.dueDate === null) return 1
    if (b.dueDate === null) return -1
    return a.dueDate.localeCompare(b.dueDate)
  })
}
